import { useEffect, useState } from "react";

/** State that survives leaving and re-entering a page within a tab session
 *  (sessionStorage — a fresh tab starts clean, but navigating away and back
 *  keeps the view). `ns` namespaces the key per module so modules can't
 *  collide (U14; formerly live-module-private). */
export function useSticky<T>(ns: string, key: string, initial: T): [T, (v: T) => void] {
  const storeKey = `${ns}.${key}`;
  const [val, setVal] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(storeKey);
      return raw !== null ? (JSON.parse(raw) as T) : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      sessionStorage.setItem(storeKey, JSON.stringify(val));
    } catch {
      /* private-mode / quota — degrade to in-memory only */
    }
  }, [storeKey, val]);
  return [val, setVal];
}
